var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1483,
    height: 86,
    viewBox: "0 0 1483 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.8309L48 60.2464C96 51.6618 192 34.4928 288 20.1673C384 6.05648 480 -5.74726 576 2.99824C672 11.4218 768 40.3946 864 48.8182C960 57.5637 1056 45.76 1152 48.8182C1248 51.6618 1344 68.8309 1392 77.4155L1440 86H1392C1344 86 1248 86 1152 86C1056 86 960 86 864 86C768 86 672 86 576 86C480 86 384 86 288 86C192 86 96 86 48 86H0V68.8309Z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M526 68.8309L557.9 60.2464C589.8 51.6618 653.6 34.4928 717.4 20.1673C781.2 6.05648 845 -5.74726 908.8 2.99824C972.6 11.4218 1036.4 40.3946 1100.2 48.8182C1164 57.5637 1227.8 45.76 1291.6 48.8182C1355.4 51.6618 1419.2 68.8309 1451.1 77.4155L1483 86H1451.1C1419.2 86 1355.4 86 1291.6 86C1227.8 86 1164 86 1100.2 86C1036.4 86 972.6 86 908.8 86C845 86 781.2 86 717.4 86C653.6 86 589.8 86 557.9 86H526V68.8309Z",
    fill: "gray",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.8309L31.9 60.2464C63.8 51.6618 127.6 34.4928 191.4 20.1673C255.2 6.05648 319 -5.74726 382.8 2.99824C446.6 11.4218 510.4 40.3946 574.2 48.8182C638 57.5637 701.8 45.76 765.6 48.8182C829.4 51.6618 893.2 68.8309 925.1 77.4155L957 86H925.1C893.2 86 829.4 86 765.6 86C701.8 86 638 86 574.2 86C510.4 86 446.6 86 382.8 86C319 86 255.2 86 191.4 86C127.6 86 63.8 86 31.9 86H0V68.8309Z",
    fill: "gray",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.cee90ad4966135ed9678379dea042252.svg";
export { ForwardRef as ReactComponent };